import braintree from "braintree-web";

(async () => {
    if (!document.getElementById('seven-braintree-client')) return;
    const clientTokenReq = await fetch('/api/braintree/client-token', {method: 'POST'});
    const res = await clientTokenReq.json();
    const {token: authorization} = res ?? {};

    if (authorization) {
        braintree.client.create({authorization}, (error, client) => {
            if (error) {
                document.dispatchEvent(new CustomEvent("braintree:client:error", {detail: {error}}));
            } else {
                document.dispatchEvent(new CustomEvent("braintree:client:init", {detail: {client, authorization}}));
            }
        })
    }
})();

